import axios, { type AxiosRequestConfig } from 'axios'

import { claimStoredTokens } from './tokens'

export function getApiClient(
  options?: AxiosRequestConfig,
  interceptors?: (config: AxiosRequestConfig) => AxiosRequestConfig
) {
  const baseURL = process.env['NEXT_PUBLIC_API_URL']
  const api = axios.create({ ...options, baseURL })

  api.interceptors.request.use(
    interceptors ||
      ((config) => {
        config.headers = {
          'Accept-Language': getHeaderLanguage(),
          ...config.headers,
        }

        if (typeof window !== 'undefined') {
          const { bearerToken, idToken } = claimStoredTokens()

          if (bearerToken) {
            config.headers['Authorization'] = `Bearer ${bearerToken}`
          }

          if (idToken) {
            config.headers['Auth0-IdToken'] = idToken
          }
        }

        return config
      })
  )

  return api
}

function getHeaderLanguage() {
  const fallback = 'pt'

  if (typeof window !== 'undefined') {
    return localStorage.getItem('lang') || fallback
  }

  return fallback
}
